export const WEBSITE_TRAINING_REFETCH_EVENT = 'website-training-refetch';
export const WEBSITE_TRAINING_START_EVENT = 'website-training-start';

export const dispatchWebsiteTrainingRefetch = () => {
  window.dispatchEvent(new CustomEvent(WEBSITE_TRAINING_REFETCH_EVENT));
};

export const dispatchWebsiteTrainingStart = (data) => {
  window.dispatchEvent(new CustomEvent(WEBSITE_TRAINING_START_EVENT, { detail: data }));
};
